import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useState } from 'react';
import ProfileDialog from './ProfileDialog';

export default function AuthLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const handleProfileClick = () => {
    setIsProfileOpen(true);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar onProfileClick={handleProfileClick} />
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <Box component="main" sx={{ flexGrow: 1, p: isMobile ? 1 : 3 }}>
          <Outlet context={{ onProfileClick: handleProfileClick }} />
        </Box>
      </Box>
      <ProfileDialog open={isProfileOpen} onClose={() => setIsProfileOpen(false)} />
    </Box>
  );
}
